import { useState } from 'react';
import { Nav } from 'react-bootstrap';
import BusinessProfilePanel from './BusinessProfilePanel';
import TeamProfilePanel from './TeamProfilePanel';

// AdminDashboard "Company profile" tab. Bundles the two admin-configurable public pages:
//   - Business profile — the per-vertical "About this business" shown in the homepage Businesses popup
//   - Team page        — the "Our Team" page (platform + optional per-vertical)
// (was two separate "More" menu entries; merged into one with sub-tabs.)
export default function CompanyProfilePanel() {
  const [tab, setTab] = useState('business');
  return (
    <div>
      <Nav variant="pills" className="mb-3" activeKey={tab} onSelect={(k) => k && setTab(k)}>
        <Nav.Item><Nav.Link eventKey="business">Business profile</Nav.Link></Nav.Item>
        <Nav.Item><Nav.Link eventKey="team">Team page</Nav.Link></Nav.Item>
      </Nav>
      {tab === 'business' ? <BusinessProfilePanel /> : <TeamProfilePanel />}
    </div>
  );
}
